module.exports = __webpack_public_path__ + "static/media/davIcon.d8a37302.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/davIcon.png
// module id = 642
// module chunks = 0